import React from "react";
import { FaTimes } from "react-icons/fa";
import { toastNotification } from "../../../services/notification-service";

export const QuestionImageUpload = ({
  questionIndex,
  hasImage,
  imagePreviews,
  question,
  setImagePreviews,
  setData
}) => {

    const handleRemoveImage = (questionIndex) => {
        setData((prev) => {
          const updatedQuestions = [...prev.additional_questions];
          updatedQuestions[questionIndex] = {
            ...updatedQuestions[questionIndex],
            has_image: false,
            image: null,
            imageName: "",
          };
          return {
            ...prev,
            additional_questions: updatedQuestions,
          };
        });
    
        setImagePreviews((prev) => {
          const newPreviews = { ...prev };
          delete newPreviews[`question-${questionIndex}`];
          return newPreviews;
        });
      };

    const handleQuestionImageUpload = (questionIndex, e) => {
        const file = e.target.files[0];

        if (!file) return;
    
        if (!file.type.startsWith("image/")) {
          toastNotification({
            status: "error",
            message: "Only image files are allowed",
          });
          return;
        }
    
        if (file.size >  2* 1024 * 1024) {
          toastNotification({
            status: "error",
            message: "Image size must be less than 2MB",
          });
          return;
        }
    
        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreviews((prev) => ({
            ...prev,
            [`question-${questionIndex}`]: e.target.result,
          }));
        };
        reader.readAsDataURL(file);
    
        setData((prev) => {
          const updatedQuestions = [...prev.additional_questions];
          updatedQuestions[questionIndex] = {
            ...updatedQuestions[questionIndex],
            has_image: true,
            image: file,
            imageName: file.name,
          };
          return {
            ...prev,
            additional_questions: updatedQuestions,
          };
        });
      };


  return (
    <div className="flex items-center justify-center">
      {hasImage ? (
        <div className="flex items-center">
          {imagePreviews[`question-${questionIndex}`] ? (
            <img
              src={imagePreviews[`question-${questionIndex}`]}
              alt="Question preview"
              className="h-10 w-10 object-cover rounded"
            />
          ) : question.image?.path ? (
            <img
              src={`${process.env.REACT_APP_SERVER_URL}/${question?.image?.path}`}
              alt="Question preview"
              className="h-10 w-10 object-cover rounded"
            />
          ) : question.image instanceof Blob ? (
            <img
              src={URL.createObjectURL(question.image)}
              alt="Question preview"
              className="h-10 w-10 object-cover rounded"
            />
          ) : (
            <div className="h-10 w-10 bg-gray-200 rounded flex items-center justify-center">
              <span className="text-xs text-gray-500">Image</span>
            </div>
          )}
          <button
            type="button"
            onClick={() => handleRemoveImage(questionIndex)}
            className="ml-2 text-red-500 hover:text-red-700"
            aria-label="Remove image"
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <label className="cursor-pointer">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleQuestionImageUpload(questionIndex, e)}
            className="hidden"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6 text-gray-500 hover:text-orange-500"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
            />
          </svg>
        </label>
      )}
    </div>
  );
};